var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.375H12.6996L11.0016 4.78418C10.5797 4.36195 10.0102 4.125 9.4125 4.125H5.25C4.00723 4.125 3 5.13258 3 6.375V17.625C3 18.8674 4.00723 19.875 5.25 19.875H18.75C19.9928 19.875 21 18.8674 21 17.625V8.625C21 7.38398 20.0227 6.375 18.75 6.375ZM19.3125 17.625C19.3125 17.9352 19.0601 18.1875 18.75 18.1875H5.25C4.93985 18.1875 4.6875 17.9352 4.6875 17.625V6.375C4.6875 6.06478 4.93985 5.8125 5.25 5.8125H9.38086C9.53108 5.8125 9.67241 5.871 9.77848 5.97731L12 8.0625H18.75C19.0601 8.0625 19.3125 8.31478 19.3125 8.625V17.625Z",
    fill: "#002C38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d84a7612a6886e28741022a988a6ff7d.svg";
export { ForwardRef as ReactComponent };